import 'babel-polyfill';
import 'nodelist-foreach-polyfill';


// WEBPACK FOOTER //
// ./polyfills.js